import BanksView  from "../BanksView.vue";
import BankList   from "../Pages/BankList.vue";
import BankEditor from "../Pages/BankEditor.vue";

const routes = [
  {
    path: "/mantenimiento/bancos",
    component: BanksView,
    children: [
      {
        path: "",
        name: "bank-list",
        component: BankList,
      },
      {
        path: "crear",
        name: "bank-create",
        component: BankEditor,
      },
      {
        path: ":id/editar",
        name: "bank-edit",
        component: BankEditor,
      },
    ],
  },
];

export default routes;
